import React from "react";
import { Helmet } from "react-helmet";
import { Box, Container, Grid } from "@mui/material";
import AccountProfileDetails from "../../components/account/AccountProfileDetails2";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export default function Request() {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
      <div
        className={classes.root}
        style={{ paddingRight: "20px", paddingLeft: "10px" }}
      >
        <Box
          sx={{
            backgroundColor: "background.default",
            minHeight: "100%",
            minWidth: "100%",
            py: 3,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              <Grid
                item
                lg={11.8}
                md={6}
                xs={12}
                style={{
                  margin: "auto",
                }}
              >
                <AccountProfileDetails />
              </Grid>
            </Grid>
          </Container>
        </Box>
      </div>
    </React.Fragment>
  );
}
